export default "__VITE_ASSET__BbeYMvJ3__"